<template>
  <div class="home-title" :style="{'padding-bottom':pbottom?'0':''}">
    <div class="sort-line" :class="colorWhite?'bg_white':''"></div>
    <div class="title"  :class="colorWhite?'c-white':''">
        <div class="name">{{name}}</div>
        <div class="info">{{info}}</div>
    </div>
    <div class="sort-line" :class="colorWhite?'bg_white':''"></div>
  </div>
</template>

<script>
export default {
    props:{
        name:{
            type:String,
            required:true,
            default:''
        },
        info:{
            type:String,
            required:true,
            default:''
        },
        colorWhite:{
            type:Boolean,
            default:false
        },
        pbottom:{
            type:Boolean,
            default:false
        },
    },
}
</script>

<style lang="scss" scoped>
.home-title{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #282828;
    padding: 30px 0 20px;
    .sort-line{
        width: 32px;
        height: 1px;
        background-color: #282828;
        margin: 0 70px;
    }
    .bg_white{
         background-color: #ffffff;
    }
     .title{
        text-align: center;
        color: #333333;
        .name{
            font-size: 30px;
            font-weight: bold;
        }
        .info{
            font-size: 14px;
            font-weight: 600;
        }
    }
    .c-white{
        color: #ffffff;
    }
}
</style>


// WEBPACK FOOTER //
// src/district/components/common/HomeTitle.vue